/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ScheduleDto } from '../models/schedule-dto';
import { scheduleGetScheduleById$Json } from '../fn/schedule/schedule-get-schedule-by-id-json';
import { ScheduleGetScheduleById$Json$Params } from '../fn/schedule/schedule-get-schedule-by-id-json';
import { scheduleGetScheduleById$Plain } from '../fn/schedule/schedule-get-schedule-by-id-plain';
import { ScheduleGetScheduleById$Plain$Params } from '../fn/schedule/schedule-get-schedule-by-id-plain';

@Injectable({ providedIn: 'root' })
export class ScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scheduleGetScheduleById()` */
  static readonly ScheduleGetScheduleByIdPath = '/api/Schedule/{scheduleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleGetScheduleById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleGetScheduleById$Plain$Response(params: ScheduleGetScheduleById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleDto>> {
    return scheduleGetScheduleById$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleGetScheduleById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleGetScheduleById$Plain(params: ScheduleGetScheduleById$Plain$Params, context?: HttpContext): Observable<ScheduleDto> {
    return this.scheduleGetScheduleById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduleDto>): ScheduleDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleGetScheduleById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleGetScheduleById$Json$Response(params: ScheduleGetScheduleById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleDto>> {
    return scheduleGetScheduleById$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleGetScheduleById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleGetScheduleById$Json(params: ScheduleGetScheduleById$Json$Params, context?: HttpContext): Observable<ScheduleDto> {
    return this.scheduleGetScheduleById$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduleDto>): ScheduleDto => r.body)
    );
  }

}
